import { createContext } from "react";
import type { Toast } from "../components/ui/Toast";
export interface ToastContextType {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, "id">) => string;
  removeToast: (id: string) => void;
  clearToasts: () => void;
  // Convenience methods
  showSuccess: (
    title: string,
    message?: string,
    options?: Partial<Toast>,
  ) => string;
  showError: (
    title: string,
    message?: string,
    options?: Partial<Toast>,
  ) => string;
  showWarning: (
    title: string,
    message?: string,
    options?: Partial<Toast>,
  ) => string;
  showInfo: (
    title: string,
    message?: string,
    options?: Partial<Toast>,
  ) => string;
}
export const ToastContext = createContext<ToastContextType | undefined>(
  undefined,
);
